import axios from "axios";

interface AssignInvoiceParams {
  userId: string | number | null;
  invoiceId: string | number;
}

export const assignInvoice = ({
  userId,
  invoiceId,
}: AssignInvoiceParams): Promise<unknown> =>
  axios
    .post("invoices/assign", {
      userId,
      invoiceId,
    })
    .then((res) => res.data);

export default assignInvoice;
